import {
    HttpClient,
    HttpErrorResponse
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
    Observable,
    throwError
} from "rxjs";
import {
    catchError,
    map
} from "rxjs/operators";
import { IPartnerBranding } from "../domain/partner-branding.model";
import { ApiEndpointService } from "./api-endpoint.service";

/**
 * SAN-384/386 — fetches a spoke partner's white-label branding from
 * `GET partner-branding/:abbreviation` (sc-saas-backend, SAN-387, shipped).
 *
 * Deliberately toast-free, unlike most services in this folder: this call is
 * fired automatically at bootstrap for any visitor on a spoke subdomain, and a
 * partner may simply have no white-label branding configured (the route
 * degrades to a 200 with just the org logo in that case, not a 404 — a 404
 * now only means a genuinely unknown abbreviation). Either way this is a
 * "keep the tenant-wide branding" signal, not something to shout at a visitor
 * about. The error is still propagated so the effect can record it in the
 * state slice.
 */
@Injectable({
    providedIn: "root"
})
export class PartnerBrandingService {

    constructor(private http: HttpClient) { }

    public getPartnerBranding(abbreviation: string): Observable<IPartnerBranding> {
        const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.PARTNER_BRANDING) + abbreviation;
        return this.http.get(url).pipe(
            map((response: any) => {
                return response?.data;
            }),
            catchError((fault: HttpErrorResponse) => {
                return throwError(() => fault);
            })
        );
    }

}
